export default __webpack_public_path__ + "assets/pdf/FT_ZMix.51990dbf.pdf";